/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class UploadTrackingProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		window.Mixins =
		{
			currentlyUploading: 0,
		};

		this.trackedUploads = [];
		this.nextUploadID = 0;
	}

	/**
	 * Adds an upload to the list of uploads being tracked, then sets the numeric flag that FB ios looks for.
	 * Gives back an id that can be used to remove the upload from the list later.
	 *
	 * @return {Number} - An id that can be used to untrack the upload later.
	 */
	trackUpload()
	{
		// Generating an error, not for the error but just to retain a copy of the stack.
		const error = new Error();
		// Monotonic rather than a timestamp: two uploads starting in the same millisecond would otherwise
		// share an id, and untracking either one would clear both while a transfer was still in flight.
		const id = ++this.nextUploadID;
		this.trackedUploads.push(
			{
				id,
				stack: error.stack,
			},
		);
		window.Mixins.currentlyUploading = this.trackedUploads.length;
		return id;
	}

	/**
	 * Removes an upload from the list of uploads being tracked using its id.
	 * @param {Number} id - An id passed from the calling function, should be the same one used to originally add the upload.
	 */
	untrackUpload(id)
	{
		this.trackedUploads = this.trackedUploads.filter((u) =>
		{
			return u.id !== id;
		});
		window.Mixins.currentlyUploading = this.trackedUploads.length;
	}
}

module.exports = UploadTrackingProvider;
module.exports.default_configuration = {};
